import React, { useState } from 'react'
import { Box, Icon } from '@chakra-ui/react'
import { FaArrowLeft, FaEllipsis, FaPaw } from 'react-icons/fa6'
import { Menu, MenuButton, MenuList } from '@chakra-ui/react'
import ActionButton from '~components/shared/buttons/action-button'

import CopyMessageAction from './copy-message'
import AdminCopyIdAction from './admin-copy-id'
import WritebackMessageAction from './writeback-message'
import RemoveAttachedPatient from './remove-attached-patient'
import AttachPatientSubmenu from './attach-patient-submenu'
import MenuItem from '~components/shared/menu/menu-item'
import {
    ChatFieldsFragment,
    ChatMessageFieldsFragment,
} from '~graphql/generated/graphql'

export interface MessageActionsProps {
    message: ChatMessageFieldsFragment
    chat: ChatFieldsFragment
}

export default function MessageActions({ message, chat }: MessageActionsProps) {
    const [isAssigningPatient, setIsAssigningPatient] = useState(false)

    return (
        <Box
            onClick={e => {
                e.preventDefault()
                e.stopPropagation()
            }}
        >
            <Menu
                closeOnSelect={false}
                onClose={() => {
                    setIsAssigningPatient(false)
                }}
            >
                <MenuButton
                    as={ActionButton}
                    size="xs"
                    variant="ghost"
                    color="gray.600"
                    _hover={{
                        bg: 'transparent',
                        color: 'gray.900',
                    }}
                    _active={{
                        bg: 'transparent',
                        color: 'brand.900',
                    }}
                    icon={<Icon as={FaEllipsis} fontSize="16px" />}
                />
                <MenuList maxH="300px" overflow="auto" bg="white">
                    {isAssigningPatient ? (
                        <>
                            <MenuItem
                                icon={FaArrowLeft}
                                onClick={() => setIsAssigningPatient(false)}
                            >
                                Back
                            </MenuItem>
                            <AttachPatientSubmenu
                                message={message}
                                chat={chat}
                            />
                        </>
                    ) : (
                        <>
                            <MenuItem
                                icon={FaPaw}
                                onClick={() => setIsAssigningPatient(true)}
                            >
                                Assign Patients
                            </MenuItem>
                            <RemoveAttachedPatient message={message} />
                            <CopyMessageAction message={message} />
                            <WritebackMessageAction
                                message={message}
                                chat={chat}
                            />
                            <AdminCopyIdAction message={message} />
                        </>
                    )}
                </MenuList>
            </Menu>
        </Box>
    )
}
